'use strict';

module Patersons {

    export interface NavbarScope extends ng.IScope {
        id: string;
        editMode: boolean;
        events: any;
        isLoggedIn: boolean;
        isNavCollapsed: boolean;
        profile: UserProfile;
        changeRequestCount: number;
        adviserList: Array<Patersons.ClientAdviser>;
        userCompany: UserCompany;
        themeRGB: any;
    }

    export class NavbarCtrl {
        scope: Patersons.NavbarScope;
        rootScope: ng.IRootScopeService;
        location;
        window;
        stateParams;
        http: ng.IHttpService;
        sessionService: Patersons.SessionService;
        clientConfigService: Patersons.ClientConfigService;
        userCompanyService: Patersons.UserCompanyService;
        static $inject = ['$scope', '$rootScope', '$location', '$window', '$stateParams', '$http', 'sessionService', 'clientConfigService', 'userCompanyService'];

        constructor($scope, $rootScope, $location, $window, $stateParams, $http, sessionService, clientConfigService,userCompanyService) {
            this.scope = $scope;
            this.rootScope = $rootScope;
            this.location = $location;
            this.window = $window;
            this.stateParams = $stateParams;
            this.http = $http;
            this.sessionService = sessionService;
            this.clientConfigService = clientConfigService;
            this.userCompanyService = userCompanyService;

            this.scope.editMode = false;
            this.scope.events = this;
            this.scope.isLoggedIn = this.sessionService.isLoggedIn();
            this.scope.isNavCollapsed = true;
            this.scope.adviserList = [];
            console.log('adviserList');
            console.log(this.scope.adviserList);
            
            if (this.scope.isLoggedIn) {
            //console.log('loadAdviserData');
                this.scope.profile = this.sessionService.getCurrentUserProfile();
                this.loadAdviserData();
                this.loadPendingChangeRequestCount();
                this.load();
                
            }
            else{

              this.scope.adviserList = [];
            }
            this.userCompanyService.getUserCompany().then((company) => {
              this.scope.userCompany = company;
              this.scope.themeRGB = this.hexToRgb(company.colorSecondary);
            })
            this.rootScope.$on('changeRequestActioned', function (event: ng.IAngularEvent, data: any) {
                $scope.changeRequestCount -= 1;
            });

            console.log('Navbar load');
        }
        hexToRgb(hex) {
          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
          return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
          } : null;
        }
        load(){
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                    initComponent('component-autocomplete-top', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteHeader').then(function () {
                        console.log('Done loading autocomplete.');
                        morningstar.asterix.instanceRegistry.find('ecAutocompleteHeader').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                            if(newVal.secId){
                                window['openAutocompleteResult'](newVal) //declared in autocomplete config
                                morningstar.asterix.instanceRegistry.get('ecAutocompleteHeader').setParameter('search', '');
                            }
                        });
                    });
                    initComponent('component-autocomplete-top-2', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteHeader2').then(function () {
                        console.log('Done loading autocomplete.');
                        morningstar.asterix.instanceRegistry.find('ecAutocompleteHeader2').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                            if(newVal.secId){
                                window['openAutocompleteResult'](newVal) //declared in autocomplete config
                                morningstar.asterix.instanceRegistry.get('ecAutocompleteHeader2').setParameter('search', '');
                            }
                        });
                    });
                    initComponent('component-autocomplete-top-3', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteHeader3').then(function () {
                        console.log('Done loading autocomplete.');
                        morningstar.asterix.instanceRegistry.find('ecAutocompleteHeader3').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                            if(newVal.secId){
                                window['openAutocompleteResult'](newVal) //declared in autocomplete config
                                morningstar.asterix.instanceRegistry.get('ecAutocompleteHeader3').setParameter('search', '');
                            }
                        });
                    });

            });
        }

        login() {
            this.sessionService.login();
        }

        logout() {
            this.sessionService.logout();
        }

        loadAdviserData() {
          console.log('loadAdviserData');
            var promise = this.clientConfigService.getAdviser();
            promise.then((result) => {
                //this.scope.$apply(() => {
                    console.log('Loaded advisers');
                    console.log(result);
                    this.scope.adviserList = result;
                //});
            },
              (reason) => {
                  this.clientConfigService.errorHandler = reason.data;
              }
            )
        }

        loadPendingChangeRequestCount() {
            console.log('loadPendingChangeRequestCount');
            var promise = this.clientConfigService.getChangeRequestCount();
            promise.then((result) => {
                //this.scope.$apply(() => {
                  console.log('Loaded change requests');
                  console.log(result);
                    this.scope.changeRequestCount = result;
                //});
            },
                (reason) => {
                    this.clientConfigService.errorHandler = reason.data;
                }
            )
        }
    }
}
